/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AgGrid from 'DesignSystem/AgGrid/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/New/TreatmentCard/Events/Content/Content/Events/Content/Compact/Past/Content/Content",
  height,
  columnDefs,
  rowData,
  isFullWidthRow,
  fullWidthCellRenderer,
  processCellForClipboard
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let userLocationPreferencesCompactTablePresetsValueData = fromData.useDataValue({ viewPath,
context: 'user_location_preferences',
path: 'compact_table_presets',
})
let onChangeTablePreset = fromHelpers.useOnChangeTablePreset({
  children,
  viewPath,
  height,
  columnDefs,
  rowData,
  isFullWidthRow,
  fullWidthCellRenderer,
  processCellForClipboard
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z1Yf8zk': dtColorsNeutral400,'--bblr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<AgGrid
  viewPath={`${viewPath}/AgGrid`}
 height={height}
 headerHeight={30}
 rowGroupPanelShow="never"
 verticalBorders={true}
 scrollToEnd={true}
 shortContextMenu={true}
 overlayNoRowsTemplate="No past appointments found"
 columnDefs={columnDefs}
 rowData={rowData}
 data="user_location_preferences.compact_table_presets"
 tablePreset={userLocationPreferencesCompactTablePresetsValueData}
 onChangeTablePreset={onChangeTablePreset}
 isFullWidthRow={isFullWidthRow}
 fullWidthCellRenderer={fullWidthCellRenderer}
 processCellForClipboard={processCellForClipboard}
 tooltipShowDelay={500}
/>
</div>
</div>
{children}
</React.Fragment>)
}